export interface Auth {
  user: null;
}

export enum AUTH {
  LOGIN = "AUTH_LOGIN",
}
